module.exports = __webpack_public_path__ + "img/IMG-20200823-WA0045.a11ad063.jpg";